export const TABLE_HEADERS = [
    { lable: "Employee Name" , minWidth: 230 },
    { lable: "Email" ,  minWidth: 280 },
    { lable: "Role", minWidth: 200},
    { lable: "Home Project" , minWidth: 200 },
    { lable: "Receive Notification", minWidth: 200 },
    { lable: "Actions" , minWidth: 50 }
];